<ng-container *ngIf="!loading; else loadingTmp">
  <img
    *ngIf="src; else noLogoTmp"
    class="logo"
    [src]="src"
    [class.tui-skeleton]="loading"
    [class.tui-skeleton_text]="loading"
    [ngStyle]="{ 'max-width': width + 'px' }"
    [attr.width]="'auto'"
    [attr.height]="height"
    alt="Logo"
  />
</ng-container>

<ng-template #loadingTmp>
  <span>loading</span>
</ng-template>

<ng-template #noLogoTmp>
  <span>no logo</span>
</ng-template>
